export type HorVerLayout = 'horizontal' | 'vertical';

export enum LayoutTypes {
  horizontal = 'horizontal',
  vertical = 'vertical',
}
